import React from "react";

const SecurityManagement = () => {
  const securityFeatures = [
    {
      title: "All CPUs & Monitors",
      subtitle: "(Including Buffers are Sealed and Signed)",
      color: "#667EEA",
      gradient: "linear-gradient(135deg, #667EEA 0%, #764BA2 100%)",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="2"
            y="4"
            width="20"
            height="16"
            rx="2"
            stroke="white"
            strokeWidth="2"
          />
          <rect x="6" y="8" width="4" height="4" fill="white" />
          <rect x="14" y="8" width="4" height="4" fill="white" />
          <rect x="6" y="14" width="12" height="2" fill="white" />
        </svg>
      ),
    },
    {
      title: "Labs & Server Rooms",
      subtitle: "are properly Sealed & Locked",
      color: "#48BB78",
      gradient: "linear-gradient(135deg, #48BB78 0%, #38A169 100%)",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="3"
            y="11"
            width="18"
            height="10"
            rx="2"
            stroke="white"
            strokeWidth="2"
          />
          <circle cx="12" cy="16" r="1" fill="white" />
          <path
            d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      ),
    },
    {
      title: "Staff ID Cards",
      subtitle: "are Compulsory",
      color: "#ED8936",
      gradient: "linear-gradient(135deg, #ED8936 0%, #DD6B20 100%)",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="3"
            y="4"
            width="18"
            height="16"
            rx="2"
            stroke="white"
            strokeWidth="2"
          />
          <circle cx="9" cy="9" r="2" stroke="white" strokeWidth="2" />
          <path
            d="M15 9H19"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M15 13H19"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M6 17C6 15.3431 7.34315 14 9 14C10.6569 14 12 15.3431 12 17"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      ),
    },
    {
      title: "Real-time Video Surveillance",
      subtitle: "through strategically placed CCTV cameras is a must",
      color: "#F56565",
      gradient: "linear-gradient(135deg, #F56565 0%, #E53E3E 100%)",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M23 7L16 12L23 17V7Z"
            stroke="white"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <rect
            x="1"
            y="5"
            width="15"
            height="14"
            rx="2"
            stroke="white"
            strokeWidth="2"
          />
          <circle cx="8.5" cy="12" r="3" stroke="white" strokeWidth="2" />
          <circle cx="8.5" cy="12" r="1" fill="white" />
        </svg>
      ),
    },
  ];

  const galleryImages = [
    "../assets/images/SECURITY_MANAGEMENT/Picture1.png",
    "../assets/images/SECURITY_MANAGEMENT/Picture2.png",
    "../assets/images/SECURITY_MANAGEMENT/Picture3.png",
    "../assets/images/SECURITY_MANAGEMENT/Picture4.png",
    "../assets/images/SECURITY_MANAGEMENT/Picture5.png",
  ];

  return (
    <div style={{ position: "relative", padding: "30px 15px" }}>
      {/* Decorative Background */}
      <div
        style={{
          position: "absolute",
          top: "10%",
          left: "5%",
          width: "80px",
          height: "80px",
          background:
            "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
          borderRadius: "50%",
          zIndex: 0,
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          top: "60%",
          right: "10%",
          width: "120px",
          height: "120px",
          background:
            "radial-gradient(circle, rgba(255,255,255,0.05) 0%, transparent 70%)",
          borderRadius: "50%",
          zIndex: 0,
        }}
      ></div>

      <div className="container" style={{ zIndex: 1, position: "relative" }}>
        {/* Title */}
        <div className="text-center mb-4">
          <h2
                 className="text-danger title split-collab"        
          >
            SECURITY MANAGEMENT
          </h2>
          <div
            style={{
              width: "100px",
              height: "4px",
              background: "linear-gradient(90deg, #667eea, #E53E3E)",
              margin: "20px auto",
              borderRadius: "2px",
            }}
          ></div>
        </div>

        {/* Cards */}
        <div
          className="row g-4 mb-5"
          data-sal-delay="150"
          data-sal="slide-up"
          data-sal-duration="800"
        >
          {securityFeatures.map((feature, index) => (
            <div key={index} className="col-12 col-sm-6 col-lg-3">
              <div
                style={{
                  background: feature.gradient,
                  borderRadius: "20px",
                  padding: "20px 15px",
                  minHeight: "240px",
                  color: "white",
                  textAlign: "center",
                  transition: "0.3s",
                  position: "relative",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow =
                    "0 20px 40px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    width: "70px",
                    height: "70px",
                    margin: "0 auto 15px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {feature.icon}
                </div>
                <h5
                  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    marginBottom: "10px",
                  }}
                >
                  {feature.title}
                </h5>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#e0dfda",
                    opacity: 0.9,
                    margin: 0,
                    lineHeight: "1.4",
                  }}
                >
                  {feature.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Gallery */}
        <div
          style={{
            borderRadius: "20px",
            padding: "30px 15px",
            border: "1px solid rgba(0,0,0,0.05)",
            backgroundColor: "#f9f9f9",
          }}
        >
          <div className="text-center mb-4">
            <h3
              style={{
                fontSize: "2.3rem",
                fontWeight: "700",
                color: "#2D3748",
              }}
            >
              Security Implementation Gallery
            </h3>
            <p style={{ color: "#718096", fontSize: "16px" }}>
              Visual documentation of our security measures
            </p>
          </div>

          <div className="row g-3 mx-0 justify-content-center">
            {galleryImages.map((imgUrl, index) => (
              <div key={index} className="col-6 col-sm-4 col-md-3 col-lg-2">
                <div
                  style={{
                    borderRadius: "10px",
                    overflow: "hidden",
                    transition: "0.3s",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 25px rgba(0,0,0,0.1)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      paddingTop: "100%",
                      position: "relative",
                    }}
                  >
                    <img
                      src={imgUrl}
                      alt={`Security ${index + 1}`}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityManagement;
